export const MERCHANDISED_DEPARTMENTS = "merchandised-departments";
export const PRODUCTS = "products";
export const SEARCH = "search";
export const USERS = "users";
export const ADDRESSES = "addresses";
export const ORDERS = "orders";
